import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import PeriodDatesPickerContainer from "./../PeriodDatesPickerContainer";
import MonoBarView from "../../components/DashboardViews/MonoBarView";
import GlobalKpiView from "../../components/DashboardViews/GlobalKpiView";
import MultiLinesView from "../../components/DashboardViews/MultiLinesView";
import MultiGlobalKpiView from "../../components/DashboardViews/MultiGlobalKpiView";
import { getCurrentDashboardData, getKpiSelected } from "./../../selectors";

const DashboardContainer = props => {
  const data = props.data || {};
  const globalData = data.global || {};
  const retailersData = data.retailers || {};
  const sectorsData = data.sectors || {};
  const brandsData = data.brands || {};
  const kpi = props.kpi || {};
  const title = kpi && kpi.long_label ? props.kpi.long_label : "";
  const kpiNotPercent = kpi.format === "Pourcentage" || kpi.format_input === "percentage" ? "" : "p-pdg-0";
  const displayBrands = kpi.source && kpi.source.toLowerCase() === "product";
  const brandsBlockClass = displayBrands ? "p-w-2-3" : "p-w-100";
  return (
    <div className="p-stats">
      <div className="p-stats-content">
        <div className="p-al-full p-stats-dashboard-container-top">
          <div style={{ overflow: "hidden", width: "230px" }}>
            <div className="p-mrg-bot-s p-al-c-center">
              <PeriodDatesPickerContainer />
            </div>
            <div
              className={`p-content-item p-stats-dashboard-item ${kpiNotPercent}`}
              style={{ height: "calc(100% - 42px)", overflow: "hidden" }}
            >
              <GlobalKpiView title={title} kpi={kpi} data={globalData} loading={props.graphLoading} />
            </div>
          </div>
          <div className="p-content-item p-stats-dashboard-item p-scroll-x" style={{ width: "calc(100% - 240px" }}>
            <MonoBarView
              title={
                <FormattedMessage id={"ENSEIGNES"} defaultMessage={"ENSEIGNES"}>
                  {txt => <React.Fragment>{txt}</React.Fragment>}
                </FormattedMessage>
              }
              kpi={kpi}
              data={retailersData}
              loading={props.graphLoading}
            />
          </div>
        </div>
        <div className="p-al-full p-stats-dashboard-container-bot">
          <div className={`${brandsBlockClass} p-content-item p-stats-dashboard-item p-scroll-y`}>
            <MultiLinesView
              title={
                <FormattedMessage id={"SECTEURS"} defaultMessage={"SECTEURS"}>
                  {txt => <React.Fragment>{txt}</React.Fragment>}
                </FormattedMessage>
              }
              kpi={kpi}
              data={sectorsData}
              loading={props.graphLoading}
              period={props.period}
            />
          </div>
          {displayBrands && (
            <div className="p-w-1-3 p-content-item p-stats-dashboard-item p-scroll-y">
              <MultiGlobalKpiView
                title={
                  <FormattedMessage id={"MARQUES"} defaultMessage={"MARQUES"}>
                    {txt => <React.Fragment>{txt}</React.Fragment>}
                  </FormattedMessage>
                }
                kpi={kpi}
                data={brandsData}
                loading={props.graphLoading}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
//REDUX
const mapStateToProps = state => {
  const stats = state.stats || {};
  const kpi = getKpiSelected(state) || {};

  return {
    graphLoading: state.stats.graphLoading,
    data: getCurrentDashboardData(state),
    period: stats.period,
    kpi: getKpiSelected(state)
    // data: dataprice,
    // kpi: kpiprice,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/views/DashboardContainer.js